import "./NewsIndustryUpdates.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Insights from "./sections/Insights";
import Footer from "@/reusable_sections/Footer";
export default function NewsIndustryUpdatesPage() {
  return <div>
      <Header />
      <Hero />
      <Insights />
      <Footer />
    </div>;
}